import React from 'react';
import './styles/global.css';
import AsciiBackground from './components/AsciiBackground';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Skills from './components/Skills';

function App() {
  return (
    <div className="App">
      <AsciiBackground />
      <Navbar />
      <Hero />
      <Projects />
      <Experience />
      <Skills />
    </div>
  );
}

export default App;
